import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { TableCellLink } from '../../components/TableCellLink/TableCellLink';
import { TextCell } from '../../components/TextCell/TextCell';
import { ProductDescriptionCellContainer } from '../../containers/ProductDescriptionCellContainer/ProductDescriptionCellContainer';
import { UrlHelpers } from '../../service/UrlHelpers';
import { LinkTarget } from '../../typings/common';
import { GridCellProps, GridColumnDecl } from '../../typings/grid';
import { ProductsListCellItem } from '../../typings/products';

import * as keyset from './productsList.i18n';

const i18n = i18nFactory(keyset);

export enum ProductsListColumnKeys {
    ID = 'id',
    PRODUCT_NAME = 'product-name',
    PRODUCT_DESCRIPTION = 'product-description',
    PRODUCT_LINK = 'product-link'
}

const WIDTH_ID = 150;
const WIDTH_NAME = 200;
const WIDTH_DESCRIPTION = 650;
const WIDTH_LINK = 50;

const tableCellProductId: GridColumnDecl<ProductsListCellItem> = {
    title: i18n('id'),
    key: ProductsListColumnKeys.ID,
    width: WIDTH_ID,
    isResizable: false,
    fixed: true,
    isSortable: true,
    cellClass: 'products-vertically-centred',
    CellComponent: React.memo(
        ({ rowData: item }: GridCellProps<ProductsListCellItem>) => {
            return <div>{item.id}</div>;
        }
    )
};

const tableCellProductName: GridColumnDecl<ProductsListCellItem> = {
    title: i18n('product-name'),
    key: ProductsListColumnKeys.PRODUCT_NAME,
    width: WIDTH_NAME,
    isResizable: false,
    fixed: true,
    flexGrow: 1,
    isSortable: true,
    cellClass: 'products-vertically-centred',
    CellComponent: React.memo(
        ({ rowData: item }: GridCellProps<ProductsListCellItem>) => {
            return <TextCell>{item.productName}</TextCell>;
        }
    )
};

const tableCellProductDescription: GridColumnDecl<ProductsListCellItem> = {
    title: i18n('product-description'),
    key: ProductsListColumnKeys.PRODUCT_DESCRIPTION,
    width: WIDTH_DESCRIPTION,
    isResizable: false,
    flexGrow: 5,
    isSortable: false,
    cellClass: 'products-vertically-centred',
    CellComponent: React.memo(
        ({ rowData: item }: GridCellProps<ProductsListCellItem>) => {
            return <ProductDescriptionCellContainer {...item} />;
        }
    )
};

const tableCellProductLink: GridColumnDecl<ProductsListCellItem> = {
    title: '',
    key: ProductsListColumnKeys.PRODUCT_LINK,
    width: WIDTH_LINK,
    isResizable: false,
    cellClass: 'products-vertically-centred',
    isSortable: false,
    CellComponent: React.memo(
        ({ rowData: item }: GridCellProps<ProductsListCellItem>) => {
            return (
                <TableCellLink
                    href={UrlHelpers.createNewDirectUrlPathByParams(
                        'grid',
                        `campaigns?ulogin=${item.ulogin}`
                    )}
                    target={LinkTarget.blank}
                />
            );
        }
    )
};

export function getProductsListItems(): GridColumnDecl<ProductsListCellItem>[] {
    return [
        tableCellProductId,
        tableCellProductName,
        tableCellProductDescription,
        tableCellProductLink
    ];
}
